import certificateOperationPrint from '@/api/certificate-operation-print'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { grade } from '@/api/grade';

export const state = {
  ...baseState,
  certificate_type_id: null,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CERTIFICATE_TYPE_ID(state, data) {
    state.certificate_type_id = data
  },
  SET_DATE_FROM(state, data) {
    state.date_from = data
  },
  SET_DATE_TO(state, data) {
    state.date_to = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        filter: {
          certificate_type_id: context.state.certificate_type_id
        }
      },
      attrubutes
    )
    return certificateOperationPrint.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return certificateOperationPrint.store(data)
  },
  searchStudent(context, attributes = {}) {
    return certificateOperationPrint.studentCertificate({ params: attributes })
  },
  printPdf(context, data) {
    return certificateOperationPrint.printPdf({
      params: {
        ids: data.id,
        cycle_value: data.cycle_value,
        grade_id: data.grade_id,
        class_id: data.class_id,
        sc_item_subject_comp_id: data.sc_item_subject_comp_id,
        certificate_type_id: data.certificate_type_id
      }
    })
  },
  getCertificateType(context, attributes = {}) {
    return certificateOperationPrint.certificateType(attributes)
  }
}
